
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { map, take,catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Router,ActivatedRoute,ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';



import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // * localhost
  //  public apiBaseUrl: string = 'http://localhost:55088/ERAH/api/'
  //  public apiPreBaseUrl: string = 'http://localhost:55088/ERAH/'

  // .Net Host
  // public apiBaseUrl: 'https://cosmicinv.com/CosmicBillsApiQboTest/api/';
  // public apiPreBaseUrl: 'https://cosmicinv.com/CosmicBillsApiQboTest/';
  // public urlPostPDF: 'https://cosmicinv.com/CosmicBillsApiQboTest/api/Scan/UploadDocumentQbo/';

  /* Live */
  public apiBaseUrl = environment.apiBaseUrl;
  public apiPreBaseUrl = environment.apiPreBaseUrl;
  public urlPostPDF = environment.urlPostPDF;
  public qboConnectUrl = environment.qboConnectUrl;
  public stripePaymentUrl = environment.stripePaymentUrl;
  public paymentUrl= environment.paymentapp;
  public paymentreturnURL = environment.paymentreturnURL;
  

  qboConnectID: any;
  token: any;

  constructor(public http: HttpClient,
    private storage: StoreService,private router: Router ) {
    this.qboConnectID = storage.fetchQboConnectID();
    this.token = storage.fetchToken();
  }

  getHeader(): any {

    this.qboConnectID = this.storage.fetchQboConnectID();
    this.token = this.storage.fetchToken();

    return new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'CosmicBill-UserToken': (this.token != null ? this.token.toString() : 0),
        'CosmicBill-QboConnectID': (this.qboConnectID != null ? this.qboConnectID .toString() : 0),
        'CosmicBill-PlatformID': '2',
        'Cache-Control': 'no-cache'
      }
    );
  }


  getPlainHeader(): any {

    return new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'CosmicBill-PlatformID': '2',
        'Cache-Control': 'no-cache'
      }
    );
  }


  get1(endUrl: string, request: any): Response | any {
    return this.http.get("http://localhost:5275/api/" + endUrl + request, { headers: this.getHeader() })
      .pipe(map(this.extractData));

  }

  getRAHPlan(endUrl: string, request: any){
    const url="https://paymenthubapi.cosmicbills.com/api"
     return this.http.get(url + endUrl + request, { headers: this.getHeader() })
      .pipe(map(this.extractData),
      catchError(this.handleErrors));
  }

  postSaveFreePlan(endpoint: string, requestBody: any) {
    const baseUrl = "https://paymenthubapi.cosmicbills.com/api";
    const fullUrl = `${baseUrl}${endpoint}`;

    return this.http.post(fullUrl, requestBody, {
      headers: this.getHeader()
    })
    .pipe(
      map(this.extractData),
      catchError(this.handleErrors)
    );
}

  post(endUrl: string, request: any): Response | any {
    return this.http.post(this.apiBaseUrl + endUrl, request, { headers: this.getHeader() })
      .pipe(map(this.extractData),
      catchError(this.handleErrors));
  }

  postAsEndUser(endUrl: string, request: any): Response | any {
    return this.http.post(this.apiBaseUrl + endUrl, request, { headers: this.getPlainHeader() })
      .pipe(map(this.extractData));
  };

  

  get(endUrl: string, request: any): Response | any {
    return this.http.get(this.apiBaseUrl + endUrl + request, { headers: this.getHeader() })
      .pipe(map(this.extractData),
      catchError(this.handleErrors));
  }

  getwithoutreq(endUrl: string): Response | any {
    return this.http.get(this.apiBaseUrl + endUrl, { headers: this.getHeader() })
      .pipe(map(this.extractData));

  }

  
  private extractData(res: Response) {
  

    return res || {};
  }

  handleErrors(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    console.log(errorMessage);
    if(error.status == 401){
    window.alert("Your seesion is time out. Please relogin");
    window.location.href = '#/logout';
    }
    return throwError(errorMessage);
  }

 
}
